import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { WizardDraft, WizardDraftClient } from 'api/clients/WizardDraftClient'
import queryClient from 'queryClient'

export interface Data extends WizardDraft {}

export const useCreateWizardDraft = () => {
  return useMutation<Data, unknown, Omit<WizardDraft, 'id' | 'created_at' | 'updated_at'>>(
    'createWizardDraft',
    async (wizardDraft) => {
      const response = await WizardDraftClient.createDraft(wizardDraft)

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred creating your draft! Our team has been notified and we are looking into it.',
        )
      }
      return response.data
    },
    {
      onSuccess(data) {
        queryClient.setQueryData(['wizardDrafts', data.workspace_id], (oldData) => {
          return [data, ...((oldData || []) as WizardDraft[])]
        })
      },
    },
  )
}
